<template>
  <div>
    <el-drawer
      class="cust-textwhite"
      title="Notification"
      :visible.sync="isShowNotification"
    >
      <Notification :isShowNotification="isShowNotification" @func="func" />
    </el-drawer>

    <div class="flex gap-2 items-center">
      <!-- <feather-icon
        icon="BellIcon"
        @click="isShowNotification = true"
        class="text-white cursor-pointer mt-1 flex"
        :badge="notificationCount"
      /> -->
      <div class="flex" @mouseover="hover = true" @mouseleave="hover = false">
        <el-tooltip effect="light" :content="this.initialName">
          <div class="avtar bg-gray cursor-pointer">
            <p class="text-white">{{ iconInitial }}</p>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import Notification from "../../layouts/components/Notification.vue";

import { EventBus } from "@/main";
export default {
  components: {
    Notification,
  },
  data() {
    return {
      storagePercent: 0,
      formPercentage: 0,
      nonEmptyCount: 0,
      emptyCount: 0,
      circles: 0,
      progress: 50,
      emptyColorFillGradient: "#ececec",
      size: 50,

      products: [],
      smsQuantity: [],
      emailQuantity: "",
      notificationQuantity: "",
      whatsAppQuantity: "",
      addons: [],
      brand: "",
      initialName: "",
      iconInitial: "",
      hover: false,
      totalGB: 0,
      usedGB: 0,
      isShowNotification: false,
      notificationCount: 0,
    };
  },

  methods: {
    func(params) {
      if (params) {
        // this.notificationCount = params;
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    addUsernameAvatar() {
      this.initialName = this.login.name;
      this.iconInitial = this.initialName[0].toUpperCase();
    },
    async getAddOns() {
      let data = await this.$store.dispatch("billing/myAddOns");
      this.addons = data;
      let smsAddons = {};
      let emailAddons = {};
      let notifyAddons = {};
      let whatsappAddons = {};
      for (let i of this.addons) {
        if (i.addOnId.flag == "T_SMS") {
          smsAddons = i;
        }
        if (i.addOnId.flag == "WA") {
          whatsappAddons = i;
        }
        if (i.addOnId.flag == "PN") {
          notifyAddons = i;
        }
        if (i.addOnId.flag == "PT_EMAILS") {
          emailAddons = i;
        }
        if (i.addOnId.flag == "CG") {
          this.totalGB = Number(i.totalQuantity / 1024 / 1024).toFixed(2);
          this.usedGB =
            Number(i.totalQuantity / 1024 / 1024).toFixed(2) -
            Number(i.quantity / 1024 / 1024).toFixed(2);
          // for percent of gb if exceed 90%
          this.storagePercent = (100 * this.usedGB) / this.totalGB;
        }
      }
      this.smsQuantity = smsAddons;
      this.notificationQuantity = notifyAddons;
      this.whatsAppQuantity = whatsappAddons;
      this.emailQuantity = emailAddons;
    },
    async SetLayout() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };

      await this.$store.dispatch("brandProfile/getBrandProfile", payload);
      this.brand = this.brandProfile;
      if (this.brand.Layout) {
        this.$store.commit("brandProfile/SET_LAYOUT", this.brand.Layout);
      } else {
        this.$store.commit("brandProfile/SET_LAYOUT", {
          id: "01",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/1.png",
          layout: [0, 2, 3, 5, 6, 8],
        });
      }
    },

    moduleAccess(name) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === name) {
          access = x.access_control;
        }
      });
      return access;
    },
    async getProjectDetails() {
      let payload = {
        projectId: this.selectedProject._id,
      };

      let data = await this.$store.dispatch(
        "projectFile/getProjectDetails",
        payload
      );
    },
    async getBrandProfileDetails() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let getData = await this.$store.dispatch(
        "brandProfile/getBrandProfile",
        payload
      );
      let fieldsData = getData.data;
      let mainData = [];
      mainData = fieldsData.map((x) => ({
        primaryLogo: x.primaryLogo ? x.primaryLogo : "",
        alternateLogo: x.alternateLogo ? x.alternateLogo : "",
        favIcon: x.favIcon ? x.favIcon : "",
        businessCategory: x.businessCategory.name
          ? x.businessCategory.name
          : "",
        primaryFont: x.primaryFont ? x.primaryFont : "",
        secondaryFont: x.secondaryFont ? x.secondaryFont : "",
        primaryColor: x.primaryColor ? x.primaryColor : "",
        secondaryColor: x.secondaryColor ? x.secondaryColor : "",
        tertiaryColor: x.tertiaryColor ? x.tertiaryColor : "",
        successColor: x.successColor ? x.successColor : "",
        warningColor: x.warningColor ? x.warningColor : "",
        dangerColor: x.dangerColor ? x.dangerColor : "",
        mobile: x.contactDetails.mobile ? x.contactDetails.mobile : 0,
        GSTNumber: x.GSTNumber ? x.GSTNumber : "",
        bankDetails: x.bankDetails ? x.bankDetails : "",
        url: x.contactDetails.url ? x.contactDetails.url : "",
        email: x.contactDetails.email ? x.contactDetails.email : "",
        address: x.contactDetails.address ? x.contactDetails.address : "",
        instagram: x.contactDetails.instagram ? x.contactDetails.instagram : "",
        facebook: x.contactDetails.facebook ? x.contactDetails.facebook : "",
        whatsapp: x.contactDetails.whatsapp ? x.contactDetails.whatsapp : "",
        linkedin: x.contactDetails.linkedin ? x.contactDetails.linkedin : "",
        pintrest: x.contactDetails.pintrest ? x.contactDetails.pintrest : "",
        to: x.contactDetails.to ? x.contactDetails.to : "",
        from: x.contactDetails.from ? x.contactDetails.from : "",
        timezone: x.contactDetails.timezone ? x.contactDetails.timezone : "",
      }));
      for (const value in Object.values(mainData[0])) {
        if (
          Object.values(mainData[0])[value] == "" ||
          Object.values(mainData[0])[value] == 0 ||
          Object.values(mainData[0])[value] == undefined
        ) {
          this.emptyCount++;
        }
      }
      this.formPercentage = 100 - (this.emptyCount / 26) * 100;
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;
      return value ? `${image_base_url}${value}` : default_image;
    },
    clickBusinessDetails() {
      this.$router.push({ name: "branding" });
    },
    async getNotification() {
      let notificationC = 0;
      let notifications = [];

      let payload = {
        readStatus: false,
        projectName: this.selectedProject.projectName,
        todaysFilter: true,
      };
      let { data } = await this.$store.dispatch(
        "getNotify/getAllNotification",
        payload
      );
      this.notificationCount = data.length;
    },
  },
  async mounted() {
    await this.getAddOns();
    await this.getBrandProfileDetails();
    await this.SetLayout();
    await this.getProjectDetails();
    // await this.func();
    EventBus.$on("TriggerCommentsNotify", this.getNotification);
    EventBus.$on("billingExpiryNotify", this.getNotification);
    await this.getNotification();
  },
  computed: {
    ...mapState("brandProfile", [
      "brandProfile",
      "googleFontFamily",
      "layoutSelected",
    ]),
    ...mapState("modules", ["modulesList"]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("admin", ["myAddOns", "login"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
    ...mapState("user", ["latestVersion"]),
    isAdminPanel() {
      if (this.$route.name === "adminView") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    hover() {
      this.addUsernameAvatar();
    },
  },
};
</script>
<style lang="scss" scoped>
.circles {
  height: 90vmin;
  position: relative;
  width: 90vmin;

  > div {
    animation: growAndFade 3s infinite ease-out;
    background-color: dodgerblue;
    border-radius: 50%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }

  .circle1 {
    animation-delay: 1s;
  }
  .circle2 {
    animation-delay: 2s;
  }
  .circle3 {
    animation-delay: 3s;
  }
}

@keyframes growAndFade {
  0% {
    opacity: 0.25;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

body {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: 0;
}
</style>
